module.exports = __webpack_public_path__ + "static/media/companyLogo.2daae664.png";